import { render } from "./DropdownButton.vue?vue&type=template&id=a8c1f354&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"

import "./DropdownButton.vue?vue&type=style&index=0&id=a8c1f354&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c1f354"]])

export default __exports__